//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    current_step: '',
    total_step: ''
  },
  methods: {
    leftCheckEvent () {
      if (Number(this.current_step) <= 1) {
        return
      } else {
        this.$emit('leftClick')
      }
    },
    rightCheckEvent () {
      if (Number(this.current_step) >= Number(this.total_step)) {
        return
      } else {
        this.$emit('rightClick')
      }
    },
    leftDisable () {
      if (Number(this.current_step) <= 1) {
        return true
      } else {
        return false
      }
    },
    rightDisable () {
      if (Number(this.current_step) >= Number(this.total_step)) {
        return true
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/baseComponents/MyStepper.vue